import { Typography, FormControl, Grid, makeStyles, MenuItem, TextField } from "@material-ui/core";
import UniDialog from '../../../Common/UniDialog';
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { showAlertSnackbar } from "../../../../reducers/uiSlice";
import { getUserPreference } from "../../../../utilities/common";
import { updateDailyLog } from "../../../../actions/payRollAdjustmentAction";

const useStyles = makeStyles((theme) => ({
    negativeMargin: {
        marginRight: theme.spacing(-18),
    },
    orangeTextField: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'orange',
            },
            '&:hover fieldset': {
                borderColor: 'orange',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'orange',
            },
        },
        '& .MuiOutlinedInput-input': {
            color: 'orange',
        },
    }
}));

function EditDailyHourDialog(props) {
    const { t } = useTranslation('payrollAdjustment');
    const dispatch = useDispatch();
    const userPref = getUserPreference();
    const [logHours, setLogHours] = useState(0);
    const [log_id, setLogId] = useState(0);

    const classes = useStyles();

    useEffect(() => {
        setLogHours(props.driverDeatils?.date_hours || 0);
        setLogId(props.driverDeatils?.log_id || 0)
    }, [props.driverDeatils]);

    function getCurrentLocalDate() {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    }

    const handleLogHours = (event) => {
        setLogHours(event.target.value);
    };

    const handleSubmit = () => {
        const params = {
            id: log_id,
            hours: parseFloat(logHours),
        };

        if (params.hours < 0 || params.hours > 24) {
            dispatch(showAlertSnackbar({
                title: t('daily_log'),
                message: t('dialog:invalid_hours_value'),
                type: 'error'
            }));
            return;
        } else {
            dispatch(updateDailyLog(params))
                .then((response) => {
                    dispatch(showAlertSnackbar({
                        title: t('daily_log'),
                        message: t('dialog:update_daily_hours_success'),
                        type: 'success'
                    }));
                })
                .catch((error) => {
                    dispatch(showAlertSnackbar({
                        title: t('daily_log'),
                        message: t('dialog:update_daily_hours_failed'),
                        type: 'error'
                    }));
                })
                .finally(() => {
                    props.handleSearch(); // Call handleSearch in the finally block
                });
        }
    };

    return (
        <UniDialog
            title={t('edit_daily_log')}
            fullWidth
            maxWidth='sm'
            open={props.openDatailyLogDialog}
            onClose={props.closeDatailyLogDialog} // Corrected prop name
            onFinish={handleSubmit}
        >
            <Grid container spacing={3} direction="row" alignItems="center">
                <Grid item xs={6}>
                    <Typography id="editdailylogdialog_driverid_typography">{t('driver_id')}: {props.driverDeatils?.driver_id || 'Unknown'}</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography id="editdailylogdialog_drivername_typography">{t('driver_name')}: {props.driverDeatils?.name || 'Unknown'}</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography id="editdailylogdialog_logdate_typography">{t('log_date')}: {props.driverDeatils?.date || getCurrentLocalDate() || 'Unknown'}</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography id="editdailylogdialog_username_typography">{t('logged_by')}: {props.driverDeatils?.creator_id || userPref.username || 'Unknown'}</Typography>
                </Grid>
                <Grid item xs={6} className={classes.negativeMargin}>
                    <Typography variant="subtitle1" id="editdailylogdialog_dailyhour_typography">{t('daily_work_hours')}:</Typography>
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        id="editdailylogdialog_loghour_textfield"
                        className={classes.orangeTextField}
                        variant="outlined"
                        value={logHours}
                        onChange={handleLogHours}
                    />
                </Grid>
            </Grid>
        </UniDialog>
    );
}

export default EditDailyHourDialog;